import HistoryContainer from 'components/SupplierInvoice/History';
import React from 'react';
import ReactDOM from 'react-dom';
import AttachedFilesContainer from './components/AttachedFiles/AttachedFilesContainer';
import UserReplacementContainer from './components/UserReplacement/UserReplacementContainer';
import GrowlContainer from './components/Growl/GrowlContainer';
import FilesContainer from './components/Files/FilesContainer';

import config from './lib/customWindow';
import { ClientContextProvider } from 'components/Files/useClient';
import { ContentPageWrapper } from 'components/Common/ContentPageWrapper';
import AdminContainerWithRouter from 'components/Admin/AdminContainer';
import { ConfirmProvider } from 'components/Common/Confirm/ConfirmContext';

if (document.getElementById("attached-files-container")) {
  console.log("attached-files-container in");
  ReactDOM.render(
    <React.StrictMode>
      <AttachedFilesContainer fakturaId={config.fakturaId} userId={config.userId} />
    </React.StrictMode>,
    document.getElementById('attached-files-container')
  );
}

if (document.getElementById("react-growl-container")) {
  console.log("react-growl-container in");
  ReactDOM.render(
    <React.StrictMode>
      <GrowlContainer />
    </React.StrictMode>,
    document.getElementById("react-growl-container")
  );
}

if (document.getElementById("react-supplierinvoice-history-container")) {
  console.log("react-supplierinvoice-history-container in");
  ReactDOM.render(
    <React.StrictMode>
      <HistoryContainer fakturaId={config.fakturaId} supplierId={config.supplierId} />
    </React.StrictMode>,
    document.getElementById("react-supplierinvoice-history-container")
  );
}

(window as any).reactSupplierInvoiceHistoryContainerPopupOpen = () => {
  window.dispatchEvent(new CustomEvent('react-supplierinvoice-history-container-open'))
}

if (document.getElementById("react-userreplacement-container")) {
  console.log("react-userreplacement-container in");
  ReactDOM.render(
    <React.StrictMode>
      <ClientContextProvider>
        <ContentPageWrapper userId={config.userId}>
          <UserReplacementContainer userId={config.userId} />
        </ContentPageWrapper>
      </ClientContextProvider>
    </React.StrictMode>,
    document.getElementById('react-userreplacement-container')
  );
}

if (document.getElementById("react-files-container")) {
  console.log("react-files-container in");
  ReactDOM.render(
    <React.StrictMode>
      <ClientContextProvider>
        <FilesContainer userId={config.userId} />
      </ClientContextProvider>
    </React.StrictMode>,
    document.getElementById('react-files-container')
  );
}

if (document.getElementById("react-admin-container")) {
  console.log("react-admin-container in");
  ReactDOM.render(
    <React.StrictMode>
      <ConfirmProvider>
        <ClientContextProvider>
          <ContentPageWrapper userId={config.userId}>
            <AdminContainerWithRouter userId={config.userId} />
          </ContentPageWrapper>
        </ClientContextProvider>
      </ConfirmProvider>
    </React.StrictMode>,
    document.getElementById('react-admin-container')
  );
}
